export default {"src":"/_next/static/image/public/images/ic_file_png.fc975627e2ae946dfe6199dab4ec209d.svg","height":24,"width":24};